module.exports = __webpack_public_path__ + "static/logo-c35723aa3893f919032c4c33604bd696.svg";